export const formatPrice = (s: string) => {
  let float = parseFloat(s);

  const formatter = new Intl.NumberFormat('vi', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })

  return formatter.format(float);
}
